import { z } from 'zod';

export const servicenowContentTypeSchema: z.ZodNativeEnum<{
	readonly WorkItem: 'work-item';
	readonly Document: 'document';
	readonly Comment: 'comment';
	readonly Incident: 'incident';
	readonly Epic: 'epic';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Project: 'project';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
}> = z.nativeEnum({
	WorkItem: 'work-item',
	Document: 'document',
	Comment: 'comment',
	Incident: 'incident',
	Epic: 'epic',
	CatalogItem: 'catalog-item',
	RequestedItem: 'requested-item',
	Project: 'project',
	Demand: 'demand',
	KnowledgeArticle: 'knowledge-article',
} as const);
